import React, { useState, useEffect } from 'react'
import { isMobile, isDesktop } from 'react-device-detect'
import qs from 'query-string'

import './Filters.scss'

import { slugify, FILES_URL, SIZES } from '../../helpers/helpers'

const DEFAULT_SWATCH_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/maswatch-default-96.png'

const Filters = React.memo(
    ({
        filters,
        variants,
        variantsWithInventory,
        handleFilterClick,
        handleClearAll,
        queryString,
        setFilters,
        showFilters,
        handleShowFilters,
    }) => {
        // console.log('filters in filters', filters)

        const [showSize, setShowSize] = useState(false)
        const [showPrint, setShowPrint] = useState(false)
        const [showType, setShowType] = useState(false)
        const [showGender, setShowGender] = useState(false)

        let sizeFilters
        let printFilters
        let typeFilters
        let genderFilters

        sizeFilters = filters.filter((f) => {
            return f.filterType === 'opt_size'
        })

        let sizeFilterValues

        if (sizeFilters.length > 0) {
            sizeFilterValues = sizeFilters[0].values
            sizeFilterValues = sizeFilterValues.filter((f) => {
                return f.key?.indexOf('Cash Gift') === -1
            })

            sizeFilterValues.sort(function(a, b){
                return SIZES.indexOf(a.key) - SIZES.indexOf(b.key);
            });

        }

        printFilters = filters.filter((f) => {
            return f.filterType === 'opt_pattern'
        })

        typeFilters = filters.filter((f) => {
            return f.filterType === 'product_type'
        })

        genderFilters = filters.filter((f) => {
            return f.filterType === 'opt_gender'
        })

        // console.log('sizeFilters', sizeFilters)
        // console.log('typeFilters', typeFilters)

        useEffect(() => {
            const queryString = window.location.search
            if (queryString) {
                let parsed = qs.parse(queryString)
                // console.log(
                //     'queryString in Filters, parsed',
                //     queryString,
                //     parsed
                // )
                if (parsed.pf_opt_size) {
                    setShowSize(true)
                }
                if (parsed.pf_opt_pattern) {
                    setShowPrint(true)
                }
                if (parsed.pf_pt_product_type) {
                    setShowType(true)
                }
                if (parsed.pf_opt_gender) {
                    setShowGender(true)
                }
            } else {
                // console.log('no queryString in Filters')
                setShowSize(false)
                setShowPrint(false)
                setShowType(false)
                setShowGender(false)
            }
        }, [filters])

        // const handleShowFilters = (e) => {
        //     console.log('Filters + clicked', e.target)
        //     setShowFilters(!showFilters)
        // }

        return (
            <div
                className={`filters-outer filters-vertical ${
                    showFilters ? 'filters-open' : ''
                }`}
                aria-label="Product Filters"
            >
                <div className="filters-inner">
                    <h2 className="filters-heading">
                        <span
                            className={
                                isDesktop ? 'desktop-heading' : 'desktop-hidden'
                            }
                        >
                            Filter By{' '}
                        </span>
                        <span
                            className={
                                isMobile ? 'mobile-heading' : 'mobile-hidden'
                            }
                            onClick={(e) => handleShowFilters(e)}
                        >
                            Filter{' '}
                            <span className={`plus`}>
                                {showFilters ? '-' : '+'}
                            </span>
                        </span>
                        <span
                            className="clear-all clear-all-desktop"
                            onClick={() => {
                                handleClearAll()
                            }}
                        >
                            Clear All
                        </span>
                    </h2>
                    <ul className="filters-list nostyle">
                        <span
                            className="clear-all-mobile"
                            onClick={() => {
                                handleClearAll()
                            }}
                        >
                            Clear All
                        </span>
                        <li
                            className={`collection-filter size-filter ${
                                showSize ? 'filter-showing' : ''
                            }`}
                            key="size-filter"
                        >
                            <div className="filter-heading">
                                <h4 onClick={() => setShowSize(!showSize)}>
                                    Size{' '}
                                    <span
                                        className={`filter-clear size-clear ${
                                            showSize ? 'show-clear' : ''
                                        }`}
                                        onClick={(e) => {
                                            handleFilterClick({
                                                filterType: 'pf_opt_size[]=',
                                                value: 'clear',
                                                option: 'opt_size',
                                            })
                                        }}
                                    >
                                        Clear
                                    </span>
                                </h4>
                            </div>
                            <div data-options="size" className="filter-options">
                                <ul className="filter-sizes nostyle filter-list">
                                    {sizeFilterValues && sizeFilterValues.length
                                        ? sizeFilterValues.map((s) => {
                                                // console.log('s in sizeFilters map', s)
                                              if (s.key && s.doc_count !== 0) {
                                                  return (
                                                      <li
                                                          className={`filter-size ${
                                                              s.selected
                                                                  ? 'filter-selected'
                                                                  : ''
                                                          }`}
                                                          data-value={s.key}
                                                          key={s.key}
                                                          onClick={(e) => {
                                                              handleFilterClick(
                                                                  {
                                                                      filterType:
                                                                          'pf_opt_size[]=',
                                                                      value: s.key,
                                                                      option: 'opt_size',
                                                                  }
                                                              )
                                                          }}
                                                      >
                                                          {s.key}
                                                      </li>
                                                  )
                                              }
                                              return null
                                          })
                                        : null}
                                </ul>
                            </div>
                        </li>
                        <li
                            className={`collection-filter print-filter ${
                                showPrint ? 'filter-showing' : ''
                            }`}
                            key="print-filter"
                        >
                            <div className="filter-heading">
                                <h4 onClick={() => setShowPrint(!showPrint)}>
                                    Prints + Colors{' '}
                                    <span
                                        className={`filter-clear prints-clear ${
                                            showPrint ? 'show-clear' : ''
                                        }`}
                                        onClick={(e) => {
                                            handleFilterClick({
                                                filterType: 'pf_opt_pattern[]=',
                                                value: 'clear',
                                                option: 'opt_pattern',
                                            })
                                        }}
                                    >
                                        Clear
                                    </span>
                                </h4>
                            </div>
                            <div className="filter-options">
                                <ul className="filter-prints nostyle filter-list">
                                    {printFilters && printFilters.length
                                        ? printFilters[0].values.map((p, i) => {
                                              if (p.key) {
                                                  let printSlug = slugify(p.key)
                                                  return (
                                                      <li
                                                          className={`filter-print ${
                                                              p.selected
                                                                  ? 'filter-selected'
                                                                  : ''
                                                          }`}
                                                          data-value={p.key}
                                                          key={p.key}
                                                          onClick={(e) => {
                                                              handleFilterClick(
                                                                  {
                                                                      filterType:
                                                                          'pf_opt_pattern[]=',
                                                                      value: p.key,
                                                                      option: 'opt_pattern',
                                                                  }
                                                              )
                                                          }}
                                                          data-balloon-blunt
                                                          data-balloon-pos={
                                                              i < 6
                                                                  ? 'down'
                                                                  : 'up'
                                                          }
                                                          aria-label={p.key}
                                                      >
                                                          <img
                                                              src={`${FILES_URL}maswatch-${printSlug}-96.png`}
                                                              alt={`${p.key} swatch`}
                                                              onError={(e) => {
                                                                  if (
                                                                      e.target
                                                                          .src !==
                                                                      DEFAULT_SWATCH_IMAGE_SRC
                                                                  ) {
                                                                      e.target.onerror =
                                                                          null
                                                                      e.target.src =
                                                                          DEFAULT_SWATCH_IMAGE_SRC
                                                                  }
                                                              }}
                                                          />
                                                      </li>
                                                  )
                                              }
                                              return null
                                          })
                                        : null}
                                </ul>
                            </div>
                        </li>
                        <li
                            className={`collection-filter type-filter ${
                                showType ? 'filter-showing' : ''
                            }`}
                            key="type-filter"
                        >
                            <div className="filter-heading">
                                <h4 onClick={() => setShowType(!showType)}>
                                    Product Type{' '}
                                    <span
                                        className={`filter-clear type-clear ${
                                            showType ? 'show-clear' : ''
                                        }`}
                                        onClick={(e) => {
                                            handleFilterClick({
                                                filterType:
                                                    'pf_pt_product_type[]=',
                                                value: 'clear',
                                                option: 'product_type',
                                            })
                                        }}
                                    >
                                        Clear
                                    </span>
                                </h4>
                            </div>
                            <div className="filter-options">
                                <ul className="filter-types nostyle filter-list">
                                    {typeFilters && typeFilters.length
                                        ? typeFilters[0].values.map((t) => {
                                              //   console.log('t in typeFilters', t)
                                              if (t.key) {
                                                  return (
                                                      <li
                                                          className={`filter-type ${
                                                              t.selected
                                                                  ? 'filter-selected'
                                                                  : ''
                                                          }`}
                                                          data-value={t.key}
                                                          key={t.key}
                                                          onClick={(e) => {
                                                              handleFilterClick(
                                                                  {
                                                                      filterType:
                                                                          'pf_pt_product_type[]=',
                                                                      value: t.key,
                                                                      option: 'product_type',
                                                                  }
                                                              )
                                                          }}
                                                      >
                                                          {t.key}
                                                      </li>
                                                  )
                                              }
                                              return null
                                          })
                                        : null}
                                </ul>
                            </div>
                        </li>

                        <li
                            className={`collection-filter gender-filter ${
                                showGender ? 'filter-showing' : ''
                            }`}
                            key="gender-filter"
                        >
                            <div className="filter-heading">
                                <h4 onClick={() => setShowGender(!showGender)}>
                                    Gender{' '}
                                    <span
                                        className={`filter-clear gender-clear ${
                                            showGender ? 'show-clear' : ''
                                        }`}
                                        onClick={(e) => {
                                            handleFilterClick({
                                                filterType: 'pf_opt_gender[]=',
                                                value: 'clear',
                                                option: 'opt_gender',
                                            })
                                        }}
                                    >
                                        Clear
                                    </span>
                                </h4>{' '}
                            </div>
                            <div className="filter-options">
                                <ul className="filter-genders nostyle filter-list">
                                    {genderFilters && genderFilters.length
                                        ? genderFilters[0].values.map((g) => {
                                              if (g.key) {
                                                  return (
                                                      <li
                                                          className={`filter-type ${
                                                              g.selected
                                                                  ? 'filter-selected'
                                                                  : ''
                                                          }`}
                                                          data-value={g.key}
                                                          key={g.key}
                                                          onClick={(e) => {
                                                              handleFilterClick(
                                                                  {
                                                                      filterType:
                                                                          'pf_opt_gender[]=',
                                                                      value: g.key,
                                                                      option: 'opt_gender',
                                                                  }
                                                              )
                                                          }}
                                                      >
                                                          {g.key}
                                                      </li>
                                                  )
                                              }
                                              return null
                                          })
                                        : null}
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
)

export default Filters
